import { useCallback, useState } from 'react';

export const useComment = () => {
    const [comment, setComment] = useState('');
    const onCommentChange = useCallback((value: string) => {
        setComment(value);
    }, []);

    const clearComment = useCallback(() => {
        setComment('');
    }, []);

    return {
        comment,
        onCommentChange,
        clearComment,
    };
};
